export default function Marker() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 413.099 413.099">
      <path d="M 206.549 0 L 206.549 0 c -82.6 0 -149.3 66.7 -149.3 149.3 c 0 28.8 9.2 56.3 22 78.899 l 97.3 168.399 c 6.1 11 18.4 16.5 30 16.5 c 11.601 0 23.3 -5.5 30 -16.5 l 97.3 -168.299 c 12.9 -22.601 22 -49.601 22 -78.901 C 355.849 66.8 289.149 0 206.549 0 Z M 206.549 193.4 c -30 0 -54.5 -24.5 -54.5 -54.5 s 24.5 -54.5 54.5 -54.5 s 54.5 24.5 54.5 54.5 C 261.049 169 236.549 193.4 206.549 193.4 Z" />
    </svg>
  );
}
